import React from 'react';
import { Box, Text } from '@fullstory/components';
import { EngagementMapsDetailsRow } from '../EngagementMapsDetailsRow';
import { ClickTypes } from '../../types';
import { FormattedMessage, useIntl } from 'react-intl';

export interface UsersRowProps {
  clickType: ClickTypes;
  users: number;
}

export const UsersRow: React.FC<UsersRowProps> = ({ clickType, users }) => {
  const intl = useIntl();
  return (
    <EngagementMapsDetailsRow
      data-component="UsersRow"
      icon={{ name: 'segments/users' }}
      label={{ body: intl.formatMessage({ defaultMessage: 'Users', id: 'YDMrKK' }) }}
      value={{ body: intl.formatNumber(users) }}
      tooltipContent={
        <Box>
          <Text appearance="bodySmall" color="inherit">
            <FormattedMessage
              defaultMessage="Number of users in this Segment who viewed this page and {clickType, select, error_clicked {error clicked} rage_clicked {rage clicked} dead_clicked {dead clicked} other {clicked}} anything."
              id="hN2lzc"
              values={{ clickType }}
            />
          </Text>
        </Box>
      }
    />
  );
};
